var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "p-0", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticStyle: { "text-align": "end" } },
            [
              _vm.programa
                ? _c(
                    "b-badge",
                    {
                      staticClass: "p-1",
                      attrs: { pill: "", variant: "primary" },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.programa.headerPrograma.programa"
                                  ) + ": "
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "mx-1",
                              domProps: {
                                textContent: _vm._s(_vm.programa?.clave),
                              },
                            }),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(_vm.programa?.nombre),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _vm.esPostulante
                            ? _c("b-col", [
                                _c("span", {
                                  staticClass: "ml-2",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.programa.headerPrograma.institucion"
                                      ) + ": "
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.institucion?.nombreInstitucion
                                    ),
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.esPostulante
                            ? _c(
                                "b-col",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: _vm.sede?.sede,
                                      expression: "sede?.sede",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                },
                                [
                                  _c("span", {
                                    staticClass: "ml-2",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.programa.headerPrograma.sede"
                                        ) + ": "
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.sede?.nombreDependencia
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("b-icon", {
                                    attrs: { icon: "info-circle" },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.programa
                ? _c("b-badge", { attrs: { pill: "", variant: "info" } }, [
                    _c("span", {
                      staticClass: "mx-2",
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t(
                            "apeironGwApp.programa.headerPrograma.noSelecionado"
                          )
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }